import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import eventBus from '../../utility/eventBus';

const GlobalAuthWrapper = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleLogout = () => navigate('/');
        eventBus.on('logout', handleLogout);

        return () => {
            eventBus.remove('logout', handleLogout);
        };
    }, [navigate]);

    return <Outlet />;
};

export default GlobalAuthWrapper;
